import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import {
  AddIcon,
  AssessmentIcon,
  FileOpenIcon,
  PrintIcon,
  SaveIcon,
  SettingsIcon,
} from "../../icons";
import { t } from "i18next";
import { ContainedButtonStyles } from "../../styles/GlobalStyles";
import { formatByTypeDate } from "../../utils/utils";
import { useEffect, useState } from "react";
import DateRangePicker from "./setting/DateRangePicker";

interface DateRangeProps {
  selectedPeriod: {
    year: number;
    quarter?: number;
  } | null;
  dateRange: {
    start_date: string;
    end_date: string;
  };
  setDateRange: (dateRange: { start_date: string; end_date: string }) => void;
  config: reportConfigItem | null;
}

export default function DateRange({
  selectedPeriod,
  dateRange,
  setDateRange,
  config,
}: DateRangeProps) {
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const handleDateRangeChange = (dateRange: {
    start_date: string;
    end_date: string;
  }) => {
    console.log(dateRange);
    setDateRange(dateRange);
  };

  const onCancel = () => {
    setIsPickerOpen(!isPickerOpen);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <button
            onClick={() => setIsPickerOpen(!isPickerOpen)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "0.5rem 1rem",
              border: "1px solid #d1d5db",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
              fontSize: "0.875rem",
              fontWeight: 500,
              borderRadius: "0.375rem",
              color: "#374151",
              backgroundColor: "white",
              cursor: "pointer",
              transition: "all 0.2s",
              outline: "none",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#f9fafb")
            } // hover:bg-gray-50
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "white")
            }
            onFocus={(e) => {
              e.currentTarget.style.boxShadow = "0 0 0 2px #2563eb33"; // focus:ring-blue-500 + ring offset
            }}
            onBlur={(e) => {
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            {dateRange.start_date && dateRange.end_date ? (
              <Typography
                sx={{ display: "flex", alignItems: "center", gap: "3px" }}
              >
                기간: {dateRange.start_date || "-"} ~{" "}
                {dateRange.end_date || "-"}
                <SettingsIcon sx={{ fontSize: "18px" }} />
              </Typography>
            ) : (
              <Typography
                sx={{ display: "flex", alignItems: "center", gap: "3px" }}
              >
                전체 기간 <SettingsIcon sx={{ fontSize: "18px" }} />
              </Typography>
            )}
          </button>
          {isPickerOpen && (
            <DateRangePicker
              dateRange={dateRange}
              onApply={handleDateRangeChange}
              onCancel={onCancel}
            />
          )}
        </Box>
      </Box>
    </>
  );
}
